import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_TOURNAMENT } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Tournament',
        name: 'Tournament',
        icon: 'fas fa-rocket'
    },
    {
        parent: 'Multiplayer.Tournament',
        key: 'Leaderboard',
        name: 'Leaderboard',
        icon: 'fas fa-leaf',
        route: { name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.INDEX }
    },
    {
        parent: 'Multiplayer.Tournament',
        key: 'Cycle',
        name: 'Cycle',
        icon: 'fas fa-sync-alt',
        route: { name: ROUTE_NAME_TOURNAMENT.CYCLE }
    },
    {
        parent: 'Multiplayer.Tournament',
        key: 'Medal',
        name: 'Medal',
        icon: 'fas fa-medal',
        route: { name: ROUTE_NAME_TOURNAMENT.MEDAL.INDEX }
    }
]);

export default registerRouteForModule(router);
